import { query } from '@confluence/query-preloader-tools';
import { FeatureDiscoveryQuery } from '@confluence/feature-discovery/entry-points/FeatureDiscoveryQuery';

export const preloadFeatureDiscovery = () => {
	return query({
		query: FeatureDiscoveryQuery,
	});
};
